import React from 'react';
import { cn } from '../../utils/cn';
import type { DividerProps } from './divider.types';

/**
 * Divider component for creating visual separation between content
 */
const Divider: React.FC<DividerProps> = ({ orientation = 'horizontal', thickness = 1, color, className }) => {
    const isHorizontal = orientation === 'horizontal';

    return (
        <div
            data-testid="divider"
            role="separator"
            aria-orientation={orientation}
            className={cn(isHorizontal ? 'w-full' : 'h-full', 'bg-[var(--color-neutral-10)]', className)}
            style={{
                [isHorizontal ? 'height' : 'width']: thickness,
                backgroundColor: color || undefined,
            }}
        />
    );
};

export default Divider;
